<template>
	<div class="pcon">
		<!--  -->
		<div class="pageCon flex">
			<div class="pageConL">
				<leftBox/>
			</div>
			<div class="pageConR">
				<div class="listBox f-bct">
					<div class="smallBox">
						<!-- 选项卡 -->
						<div class="navBox f-bct">
							<p class="a">Подробности посылки</p>
							<p @click="back()">Вернись на последнюю страницу</p>
						</div>
						<!-- 小包裹 -->
						<div class="smallList">
							<div class="itm">
								<div class="sn f-bct">
									<div class="t1 f-ct">
										нечетное число：<span>{{pmsg.expressNumber}}</span>
										<template>
											<p class="borMT"></p>
											<div class="manMT">n. маркировка：{{pmsg.memberCode||'？'}}</div>
										</template>
										<!-- 名称 -->
										<div class="mingcheng f-ct">
											<div class="lab">Описание：</div>
											<el-input type="text" v-model="name" placeholder=""></el-input>
											<div class="anni" style="cursor: pointer;" @click="packageMiniupdate">Сохранить</div>
										</div>
									</div>
									<div class="t2" v-if="pmsg.status==0">Недоступ.</div>
									<div class="t2" v-if="pmsg.status==1">В хранилище.</div>
									<div class="t2" v-if="pmsg.status==2">Собирайся.</div>
									<div class="t2" v-if="pmsg.status==3">Упакован.</div>
									<div class="t2" v-if="pmsg.status==4">Отправлено.</div>
									<div class="t2" v-if="pmsg.status==5">Доставлено.</div>
								</div>
								<div class="detail f-ct">
									<div class="msg f-ct">
										<el-image class="img" @click="showImgViewer([pmsg.imageUrl])" v-if="pmsg.imageUrl" :src="pmsg.imageUrl"></el-image>
										<el-image class="img" v-else :src="require('@/static/img4.png')"></el-image>
										<div class="r f-ct">
											<div class="cBox f-ct">
											<div class="nubitm">
												<el-image :src="require('@/static/icon17.png')"></el-image>
												<p>длина：{{pmsg.length||'？'}}cm</p>
											</div>
											<div class="nubitm">
												<el-image :src="require('@/static/icon18.png')"></el-image>
												<p>ширина：{{pmsg.width||'？'}}cm</p>
											</div>
											<div class="nubitm">
												<el-image :src="require('@/static/icon19.png')"></el-image>
												<p>высота：{{pmsg.height||'？'}}cm</p>
											</div>
											<div class="nubitm">
												<el-image :src="require('@/static/icon20.png')"></el-image>
												<p>объём：{{pmsg.volume||'？'}}cm³</p>
											</div>
											<div class="nubitm">
												<el-image :src="require('@/static/icon21.png')"></el-image>
												<p>выгруженный：{{pmsg.weight||'？'}}kg</p>
											</div>
											</div>
											<div class="nubitm">
												<el-image :src="require('@/static/icon22.png')"></el-image>
												<p>небольшой：{{pmsg.pieceNum||'？'}}пункт</p>
											</div>
											<div class="nubitm" v-if="pmsg.remark">
												<p>Замечание：{{pmsg.remark}}</p>
											</div>
										</div>
									</div>
									<div class="bor"></div>
									<div class="caozuo">
										<p class="t1" style="margin-top: 0.06rem;font-size: 0.12rem;" v-if="pmsg.lookDetailStatus==0" @click.stop="applyLookDetailF(pmsg.id)">Запрос на просмотр пакета</p>
										<p class="t1" style="margin-top: 0.06rem;font-size: 0.12rem;" v-if="pmsg.lookDetailStatus==1">Подать заявку на просмотр пакета</p>
										<p class="t1" style="margin-top: 0.06rem;font-size: 0.12rem;" v-if="pmsg.lookDetailStatus==2" @click.stop="showImgViewer(pmsg.lookDetailGallery)">Посмотреть пакет</p>
										
										<!-- <p class="t1">Проверь логистику.</p> -->
									</div>
								</div>
							</div>
						</div>
						<!-- 所属大包裹 -->
						<div class="bigBagMsg" v-if="pmsg.status>2">
							<div class="tit f-bct">
								<div class="tl">
									<div class="bor"></div>
									<p>Принадлежит большой упаковке</p>
								</div>
							</div>
							<div class="bagDetail f-ct">
								<div class="bagimg f-ct">
									<el-image @click="showImgViewer(packageBig.gallery)" v-if="packageBig.gallery.length" :src="packageBig.gallery[0]"></el-image>
									<el-image v-else :src="require('@/static/img4.png')"></el-image>
									<div class="bagimgR f-ct">
										<div class="nubitm">
											<el-image :src="require('@/static/icon17.png')"></el-image>
											<p>длина：{{packageBig.length||'？'}}cm</p>
										</div>
										<div class="nubitm">
											<el-image :src="require('@/static/icon18.png')"></el-image>
											<p>ширина：{{packageBig.width||'？'}}cm</p>
										</div>
										<div class="nubitm">
											<el-image :src="require('@/static/icon19.png')"></el-image>
											<p>высота：{{packageBig.height||'？'}}cm</p>
										</div>
										<div class="nubitm">
											<el-image :src="require('@/static/icon20.png')"></el-image>
											<p>объём：{{packageBig.volume||'？'}}cm³</p>
										</div>
										<div class="nubitm">
											<el-image :src="require('@/static/icon21.png')"></el-image>
											<p>выгруженный：{{packageBig.weight||'？'}}kg</p>
										</div>
										<div class="nubitm">
											<el-image :src="require('@/static/icon22.png')"></el-image>
											<p>небольшой：{{packageBig.miniPackageNum||'？'}}件</p>
										</div>
										<div class="nubitm">
											<el-image :src="require('@/static/icon32.png')"></el-image>
											<p>консистенция：{{packageBig.density||'？'}}KG/m³</p>
										</div>
										<div class="anniu" @click="link('/bigBagMsg',{id:packageBig.id})">сморщивание</div>
									</div>
								</div>
								<div class="bagCar">
									<div class="bagCarItm">
										<p class="t1">нечетное число<span>：</span></p>
										<div class="t2">
											<p>{{packageBig.bigExpressNumber}}</p>
										</div>
									</div>
									<div class="bagCarItm">
										<p class="t1">Упаковщик.<span>：</span></p>
										<div class="t2">
											<el-image v-if="packageBig.packerPortrait" :src="packageBig.packerPortrait"></el-image>
											<el-image v-else :src="require('@/static/uzw.png')"></el-image>
											<p>{{packageBig.packerName}}</p>
										</div>
									</div>
									<div class="bagCarItm">
										<p class="t1">Способ упаковать вещи<span>：</span></p>
										<div class="t2">
											<p>{{packageBig.packType}}</p>
										</div>
									</div>
									<div class="bagCarItm" v-if="packageBig.packTime">
										<p class="t1">Время собираться.<span>：</span></p>
										<div class="t2">
											<p>{{packageBig.packTime}}</p>
										</div>
									</div>
									<div class="bagCarItm" v-if="packageBig.predictTime">
										<p class="t1">Расчетное время выпуска<span>：</span></p>
										<div class="t2">
											<p>{{packageBig.predictTime}}</p>
										</div>
									</div>
									<div class="bagCarItm" v-if="packageBig.sendTime">
										<p class="t1">Время<span>：</span></p>
										<div class="t2">
											<p>{{packageBig.sendTime}}</p>
										</div>
									</div>
								</div>
							</div>
						</div>
						<!-- Номер машины -->
						<div class="bigBagMsg" v-if="pmsg.status>3">
							<div class="tit f-bct">
								<div class="tl">
									<div class="bor"></div>
									<p>Номер машины</p>
								</div>
							</div>
							<div class="bagDetail1 f-bct">
								<div class="bagCar1">
									<div class="bagCarItm">
										<p class="t1">Номер второго порядка<span>：</span></p>
										<div class="t2">
											<p>{{train.trainNumber}}</p>
										</div>
									</div>
									<div class="bagCarItm">
										<p class="t1">Водитель<span>：</span></p>
										<div class="t2">
											<el-image v-if="train.packerPortrait" :src="train.packerPortrait"></el-image>
											<el-image v-else :src="require('@/static/uzw.png')"></el-image>
											<p>{{train.packerName}}</p>
										</div>
									</div>
									<div class="bagCarItm">
										<p class="t1">Расчетное время выпуска<span>：</span></p>
										<div class="t2">
											<p>{{train.predictSendTime}}</p>
										</div>
									</div>
								</div>
								<div class="bagCar1">
									<div class="bagCarItm">
										<p class="t1">Количество посылок<span>：</span></p>
										<div class="t2">
											<p>{{train.bigPackageNum}}пункт</p>
										</div>
									</div>
									<div class="bagCarItm">
										<p class="t1">Пункт назначения<span>：</span></p>
										<div class="t2">
											<p>{{train.destination}}</p>
										</div>
									</div>
									<div class="bagCarItm" v-if="train.sendTime">
										<p class="t1">Время отправки.<span>：</span></p>
										<div class="t2">
											<p>{{train.sendTime}}</p>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="delBag" v-if="pmsg.status==0" @click="hbDel1 = true">Удалите приказ</div>
						<!--  -->
					</div>
				</div>
			</div>
		</div>
		<div class="maskBg" v-if="hbDel1"></div>
		<div class="subTips" style="width: 402px;" v-if="hbDel1">
			<el-image class="cha"  @click="hbDel1=false" :src="require('@/static/icon26.png')"></el-image>
			<div class="txt">Удалите приказ</div>
			<div class="t1">Вы уверены, что хотите удалить этот приказ？</div>
			<div class="btnBox f-ct" style="margin-top: 30px;">
				<div class="b1" @click="hbDel1=false">вернут</div>
				<div class="b2" @click="packageMiniDelete">vt. определить</div>
			</div>
		</div>
		<!-- 图片预览 -->
		<el-image-viewer v-if="imgViewerVisible" :on-close="closeImgViewer" :url-list="imgList" />
	</div>
</template>
<script>
import { packageMiniDetail,packageMiniDelete,applyLookDetail,packageMiniupdate } from "/src/api/api.js"
import {mapState,mapGetters,mapActions,mapMutations} from 'vuex'
export default {
	components: {
		'leftBox': () => import('@/components/leftBox.vue'),
		'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer'),
	},
	data(){
		return {
			imgViewerVisible:false,
			imgList:[],
			hbDel1:false,
			id:0,
			pmsg:'',
			packageBig:'',
			train:'',
			name:"",
		}
	},
	mounted() {
		this.id = this.$route.query.id
		this.packageMiniDetail()
	},
	methods:{
		// 更新小包裹
		async packageMiniupdate(){
			var data = {...this.pmsg}
			data.name = this.name
			const res = await packageMiniupdate(data)
			if(res.code==200){
				this.Tips(res.msg,'success')
			}else{this.Tips(res.msg)}
		},
		// 申请查看包裹
		async applyLookDetailF(id){
			const res = await applyLookDetail({id})
			if(res.code==200){
				this.Tips(res.msg,'success')
				this.packageMiniDetail()
			}else{this.Tips(res.msg)}
		},
		// 图预览
		showImgViewer(arr){
			this.imgList = arr
			this.imgViewerVisible = true;
			const m = (e) => { e.preventDefault() };
		},
		closeImgViewer(){
			this.imgViewerVisible = false;
		},
		// 我的小包裹详情
		async packageMiniDetail(){
			const res = await packageMiniDetail({id:this.id})
			if(res.code==200){
				this.pmsg = res.data
				this.packageBig = res.data.packageBig
				this.train = res.data.train
				this.name = res.data.name
			}else{this.Tips(res.msg)}
		},
		// 小包裹删除
		async packageMiniDelete(){
			const res = await packageMiniDelete({id:this.id})
			if(res.code==200){
				this.Tips(res.msg,'success')
				this.hbDel1 = true
				this.back()
			}else{this.Tips(res.msg)}
		},
	},
	computed:{
		...mapState('userMsg',['userInfo']),
	}
}
</script>
<style lang="scss">
body{
	// background: #f6f7fb;
}
</style>
<style lang="scss" scoped>
.pcon{
	padding: 0 74px;
	padding-bottom: 46px;
}
.banner{
	width: 100%;
	height: 413px;
	.el-image{
		width: 100%;
		height: 413px;
		border-radius: 18px;
	}
	.dian{
		position: absolute;
		left: 50%;
		transform: translateX(-50%);
		bottom: 16px;
		z-index: 2;
		div{
			margin: 0 3px;
			width: 8px;
			height: 8px;
			border-radius: 8px;
			background: #00000033;
			transition:0.3s;
		}
		.a{
			background: #fff;
			width: 14px;
			transition:0.3s;
		}
	}
}
.maskBg{
	position: fixed;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	background: rgba(0, 0, 0, 0.4);
	z-index: 10;
}
.subTips{
	position: fixed;
	width: 764px;
	// height: 364px;
	padding-bottom: 34px;
	background: #fff;
	border-radius: 8px;
	z-index: 11;
	top: 50%;
	left: 50%;
	transform: translateX(-50%)translateY(-50%);
	.title{
		height: 69px;
		padding: 0 30px;
		background: #FAFBFC;
		border-radius: 8px 8px 0 0;
		margin-bottom: 40px;
		.el-image{
			width: 14px;
		}
		p{
			font-size: 18px;
		}
	}
	.cha{
		position: absolute;
		right: 20px;
		top: 20px;
		width: 14px;
		height: 14px;
	}
	.icon{
		display: block;
		margin: auto;
		margin-top: 48px;
		width: 115px;
		height: 115px;
	}
	.txt{
		font-size: 18px;
		font-weight: 600;
		color: #2F3541;
		margin-top: 35px;
		text-align: center;
	}
	.t1{
		font-size: 18px;
		color: #7D7D89;
		// font-weight: 600;
		text-align: center;
		margin-top: 25px;
		span{
			color: #38ABB0;
			padding: 0 4px;
		}
	}
	.t2{
		font-size: 18px;
		color: #FF5F5A;
		padding: 0 27px;
		text-align: center;
		margin-top: 12px;
		line-height: 28px;
		span{
			color: #2F3541;
		}
	}
	.t3{
		font-size: 14px;
		color: #999999;
		padding: 0 27px;
		text-align: center;
		margin-top: 12px;
		line-height: 28px;
		span{
			color: #2F3541;
		}
	}
	.iptBox{
		width: 403px;
		margin: auto;
		margin-bottom: 20px;
		&:last-child{
			margin-bottom: 0;
		}
		.lab{
			font-size: 16px;
			color: #9A9DA7;
			width: calc(100% - 307px);
		}
		.ipt{
			width: 307px;
			border: 1px solid #E8EDF4;
			border-radius: 8px;
			padding: 0 20px;
			height: 50px;
			display: flex;
			align-items: center;
			::v-deep .el-input__inner{
				border: none;
				padding: 0 0;
				font-size: 0.16rem;
				background: none;
			}
			.selItm{
				display: flex;
				align-items: center;
				margin-right: 80px;
				.el-image{
					width: 20px;
					margin-right: 8px;
				}
				p{
					font-size: 16px;
				}
			}
		}
	}
	.btnBox{
		margin-top: 42px;
		justify-content: center;
		div{
			width: 162px;
			height: 46px;
			border-radius: 6px;
			text-align: center;
			line-height: 46px;
			font-size: 16px;
			cursor: pointer;
		}
		.b1{
			background: #F6F6F6;
			color: #666;
		}
		.b2{
			background: #38ABB0;
			color: #fff;
			margin-left: 14px;
		}
	}
}
.delBag{
	width: 140px;
	height: 42px;
	border: 1px solid #DDDDDD;
	font-size: 16px;
	color: #666666;
	text-align: center;
	line-height: 40px;
	cursor: pointer;
	border-radius: 6px;
		background: #FF4D5A;
		border: 1px solid #FF4D5A;
		color: #fff;
		// margin-right: 12px;
		margin-top: 12px;
		margin-left: 1020px;
}
.pageCon{
	margin-top: 32px;
	justify-content: space-between;
	.pageConL{
		width: 530px;
	}
	.pageConR{
		width: calc(100% - 562px);
		.userNub{
			.itm{
				width: 382px;
				height: 158px;
				border-radius: 12px;
				background: #fff;
				padding-right: 46px;
				padding-left: 36px;
				.el-image{
					width: 80px;
				}
				.txt{
					width: calc(100% - 90px);
					margin-right: 10px;
					.t1{
						font-size: 42px;
						font-weight: bold;
					}
					.t2{
						font-size: 20px;
						color: #666666;
					}
				}
			}
		}
		.listBox{
			.tit{
				.tl{
					display: flex;
					align-items: center;
					.bor{width: 2px;height: 15px;background: #38ABB0;border-radius: 2px;}
					p{
						font-size: 18px;
						padding-left: 10px;
					}
				}
				.tr{
					display: flex;
					align-items: center;
					.el-image{
						width: 20px;
					}
					p{
						font-size: 16px;
						color: #666666;
					}
				}
			}
			.zw{
				padding-top: 0;
				.el-image{
					margin-bottom: 0;
				}
			}
			.smallBox{
				width: 100%;
				// height: 411px;
				background: #fff;
				border-radius: 12px;
				padding: 24px;
				.smallList{
					margin-top: 16px;
					// height: 340px;
					// background: pink;
					// overflow: scroll;
					.itm{
						border: 1px solid #EFF1F6;
						border-radius: 8rpx;
						margin-bottom: 16px;
						.mingcheng{
							margin-left: 42px;
							width: 372px;
							.el-input{
								width: calc(100% - 245px);
							}
							.anni{
								height: 36px;
								width: 90px;
								background: #38ABB0;
								border-radius: 4px;
								color: #fff;
								text-align: center;
								line-height: 36px;
								font-size: 14px;
								margin-left: 12px;
							}
							.lab{
								margin-right: 12px;
								color: #000;
							}
							::v-deep .el-input__inner{
								height: 0.36rem;
								// border-radius: 0.08rem;
								// border: none;
								padding: 0 12px;
								font-size: 0.14rem;
								// background: none;
							}
						}
						.sn{
							height: 56px;
							border-bottom: 1px solid #EFF1F6;
							background: #EFF1F6;
							padding: 0 24px;
							.el-image{
								display: block;
								width: 20px;
								margin-right: 12px;
								// margin-left: 24px;
							}
							.t1{
								font-size: 16px;
								color: #999999;
								span{
									color: #333;
								}
							}
							.t3{
								.snTxt{
									font-size: 16px;
									color: #999999;
									span{
										color: #333;
									}
								}
								.bor{
									width: 1px;
									height: 16px;
									background: #D9D9D9;
									margin: 0 24px;
								}
								.man{
									font-size: 16px;
								}
							}
							.t2{
								// width: 72px;
								padding: 0 6px;
								height: 30px;
								background: #C7F3F5;
								font-size: 14px;
								color: #38ABB0;
								text-align: center;
								line-height: 30px;
								border-radius: 4px;
							}
						}
						.detail{
							padding: 16px 0;
							.msg{
								width: calc(100% - 105px);
								padding-left: 24px;
								// background: pink;
								.img{
									width: 66px;
									height: 66px;
									border-radius: 6px;
									margin-right: 16px;
								}
								.r{
									width: calc(100% - 82px);
									.cBox{
										margin-bottom: 10px;
										&:last-child{
											margin-bottom: 0;
										}
									}
									.nubitm{
										display: flex;
										align-items: center;
										// margin-right: 63px;
										width: 176px;
										.el-image{
											width: 20px;
											height: 20px;
											margin-right: 6px;
										}
										p{
											font-size: 16px;
										}
									}
								}
							}
							.bor{
								width: 1px;
								height: 50px;
								background: #D9D9D9;
							}
							.caozuo{
								width: 104px;
								// background: #00000033;
								p{
									text-align: center;font-size: 16px;
									cursor: pointer;
								}
								.t1{
									color: #38ABB0;
								}
								.t2{
									color: #FF4D5A;
									margin-top: 6px;
								}
								.t3{
									color: #38ABB0;
									margin-top: 6px;
								}
							}
						}
					}
				}
			}
			.mtBox{
				width: 382px;
				height: 411px;
				background: #fff;
				border-radius: 12px;
				padding: 24px;
				.maitouList{
					margin-top: 16px;
					height: 330px;
					// background: pink;
					overflow: scroll;
					.mtItm{
						margin-bottom: 22px;
						.l{
							.nub{
								// width: 20px;
								height: 20px;
								background: #38ABB0;
								margin-right: 12px;
								color: #fff;
								border-radius: 20px;
								font-size: 13px;
								text-align: center;
								line-height: 19px;
								padding: 0 5px;
								padding-left: 6px;
							}
							.el-image{
								width: 45px;
							}
							p{
								font-size: 16px;
								padding-left: 6px;
							}
						}
						.r{
							display: flex;
							align-items: center;justify-content: flex-end;
							.bor{
								width: 1px;
								height: 16px;
								margin: 0 10px;
								background: #D9D9D9;
							}
							.btnItm{
								display: flex;
								align-items: center;
								.el-image{
									width: 14px;
									margin-right: 4px;
								}
								p{
									font-size: 14px;
								}
								.t1{
									color: #38ABB0;
								}
								.t2{
									color: #FF4D5A;
								}
							}
						}
					}
				}
				.tableImgList{
					margin-top: 16px;
					height: 340px;
					// background: pink;
					overflow: scroll;
					.el-image{
						width: 100%;
						height: 154px;
						margin-bottom: 16px;
						border-radius: 12px;
					}
				}
			}
		}
	}
}
.shaixuan{
	padding: 0 24px;
	padding-top: 24px;
	margin-bottom: 24px;
	padding-left: 0;
	.l{
		.itm{
			display: flex;
			align-items: center;
			font-size: 16px;
			margin-right: 31px;
			span{
				display: block;
				width: 90px;
				padding-right: 16px;
			}
		}
		.itm1{
			display: flex;
			align-items: center;
			font-size: 16px;
			margin-right: 31px;
			border: 1px solid #DDDDDD;
			border-radius: 4px;
			span{
				display: block;
				width: 90px;
				padding-right: 16px;
			}
			::v-deep .el-input__inner{
				background: none;
				border: none;
				padding-left: 0;
			}
			.el-image{
				display: block;
				width: 16px;
				margin-left: 16px;
				margin-right: 12px;
			}
		}
	}
	.seachBtn{
		transform: translateX(-12px);
		div{
			width: 85px;
			height: 40px;
			border: 1px solid #DDDDDD;
			font-size: 16px;
			color: #666666;
			text-align: center;
			line-height: 38px;
			cursor: pointer;
			border-radius: 6px;
			&:first-child{
				background: #38ABB0;
				border: 1px solid #38ABB0;
				color: #fff;
				margin-right: 12px;
			}
		}
	}
}
.rukuSel{
	.l{
		.el-image{
			width: 20px;
			margin-right: 12px;
		}
		span{
			font-size: 14px;
		}
	}
	.seachBtn{
		p{
			font-size: 14px;
			padding-right: 16px;
		}
		div{
			width: 128px;
			height: 40px;
			border: 1px solid #DDDDDD;
			font-size: 16px;
			color: #666666;
			text-align: center;
			line-height: 38px;
			cursor: pointer;
			border-radius: 6px;
				background: #38ABB0;
				border: 1px solid #38ABB0;
				color: #fff;
				margin-right: 12px;
		}
	}
}
.navBox{
	border-bottom: 1px solid #EEEEEE;
	// padding: 0 10px;
	p{
		// padding-top: 24px;
		padding-bottom: 16px;
		// margin-right: 56px;
		font-size: 18px;
		cursor: pointer;
		color: #7D7D89;
		&::after{
			position: absolute;
			content: '';
			width: 0%;
			height: 4px;
			border-radius: 4px;
			background: #38ABB0;
			bottom: 0%;
			left: 50%;
			transform: translateX(-50%);
			transition:0.3s;
		}
	}
	.a{
		color: #38ABB0;
		font-weight: bold;
		&::after{
			width: 100%;
			transition:0.3s;
		}
	}
}
.bigBagMsg{
	margin-top: 24px;
	border-radius: 10px;
	border: 1px solid #EEEEEE;
	padding-top: 24px;
	padding-bottom: 36px;
	.tit{
		padding-bottom: 20px;
		.tl{
			display: flex;
			align-items: center;
			.bor{width: 2px;height: 15px;background: #38ABB0;border-radius: 2px;}
			p{
				font-size: 18px;
				padding-left: 10px;
				font-weight: bold;
			}
		}
		.tr{
			display: flex;
			align-items: center;
			.el-image{
				width: 20px;
			}
			p{
				font-size: 16px;
				color: #666666;
			}
		}
	}
	.bagDetail{
		.bagimg{
			width: 572px;
			border-right: 1px solid #EBEEF5;
			padding-left: 24px;
			.el-image{
				width: 182px;
				height: 182px;
				border-radius: 6px;
				margin-right: 20px;
			}
			.bagimgR{
				width: calc(100% - 202px);
				.nubitm{
					display: flex;
					align-items: center;
					// margin-right: 63px;
					width: 164px;
					margin-bottom: 15px;
					.el-image{
						width: 20px;
						height: 20px;
						margin-right: 6px;
					}
					p{
						font-size: 16px;
					}
				}
				.anniu{
					// width: 108px;
					padding: 0 6px;
					height: 42px;
					border: 1px solid #DDDDDD;
					font-size: 16px;
					color: #666666;
					text-align: center;
					line-height: 38px;
					cursor: pointer;
					border-radius: 6px;
					background: #38ABB0;
					border: 1px solid #38ABB0;
					color: #fff;
					margin-right: 12px;
				}
			}
		}
		.bagCar{
			padding-left: 48px;
			width: calc(100% - 572px);
			// background: pink;
			padding-right: 30px;
			.bagCarItm{
				display: flex;
				align-items: center;
				justify-content: space-between;
				width: 100%;
				margin-bottom: 10px;
				// background: pink;
				.t1{
					position: relative;
					font-size: 16px;
					// span{
					// 	position: absolute;
					// }
				}
				.t2{
					font-size: 16px;
					display: flex;
					align-items: center;
					.el-image{
						width: 20px;
						height: 20px;
						border-radius: 50%;
						margin-right: 6px;
					}
				}
			}
		}
	}
	.bagDetail1{
		padding: 0 28px;
		.bagCar1{
			// width: 50%;
			width: 495px;
			// padding-left: 48px;
			// width: calc(100% - 572px);
			// background: pink;
			// padding-right: 30px;
			.bagCarItm{
				display: flex;
				align-items: center;
				justify-content: space-between;
				width: 100%;
				margin-bottom: 12px;
				// background: pink;
				.t1{
					position: relative;
					font-size: 16px;
					// span{
					// 	position: absolute;
					// }
				}
				.t2{
					font-size: 16px;
					display: flex;
					align-items: center;
					.el-image{
						width: 20px;
						height: 20px;
						border-radius: 50%;
						margin-right: 6px;
					}
				}
			}
		}
	}
}
</style>